/* eslint-disable max-len */
import * as errorEnum from './enum/error';

export default {
  'Audio Player': 'Audiospeler',
  'Video Player': 'Videospeler',
  Play: 'Afspelen',
  Pause: 'Pauzeren',
  Replay: 'Opnieuw afspelen',
  'Current Time': 'Huidige tijd',
  Duration: 'Tijdsduur',
  'Remaining Time': 'Resterende tijd',
  'Stream Type': 'Streamtype',
  LIVE: 'LIVE',
  Loaded: 'Geladen',
  Progress: 'Voortgang',
  'Progress Bar': 'Voortgangsbalk',
  'progress bar timing: currentTime={1} duration={2}': '{1} van {2}',
  Fullscreen: 'Volledig scherm',
  'Non-Fullscreen': 'Geen volledig scherm',
  Mute: 'Dempen',
  Unmute: 'Niet dempen',
  'Playback Rate': 'Afspeelsnelheid',
  Subtitles: 'Ondertiteling',
  'subtitles off': 'Uit',
  Captions: 'Bijschriften',
  'captions off': 'Bijschriften uit',
  Chapters: 'Hoofdstukken',
  Descriptions: 'Beschrijvingen',
  'descriptions off': 'Beschrijvingen uit',
  'Audio Track': 'Audiospoor',
  'Volume Level': 'Geluidsniveau',
  'You aborted the media playback':
    'U heeft het afspelen van de media afgebroken',
  [errorEnum.NET_ERR]:
    'Een netwerkfout heeft ervoor gezorgd dat het downloaden van de media halverwege is mislukt.',
  [errorEnum.MED_ERR]:
    'De media kon niet worden geladen, dit komt doordat de server of het netwerk mislukt of doordat het formaat niet wordt ondersteund.',
  [errorEnum.PLAY_ERR]:
    'Het afspelen van de media is afgebroken door een probleem met beschadeigde gegevens of doordat de media functies gebruikt die uw browser niet ondersteund.',
  [errorEnum.MED_TYPE_ERR]:
    'Er is geen geschikte bron voor deze media gevonden.',
  [errorEnum.CR_ERR]:
    'De media is versleuteld en we hebben de sleutels niet om deze te ontsleutelen.',
  'Play Video': 'Video afspelen',
  Close: 'Sluiten',
  'Close Modal Dialog': ' ',
  'Modal Window': 'Extra venster',
  'This is a modal window': 'Dit is een extra venster',
  [errorEnum.ERR]:
    'Dit venster kan worden gesloten door op de Escape-toets te drukken of door de sluiten-knop te activeren.',
  ', opens captions settings dialog':
    ', opent instellingen-venster voor bijschriften',
  ', opens subtitles settings dialog':
    ', opent instellingen-venster voor ondertitelingen',
  ', opens descriptions settings dialog':
    ', opent instellingen-venster voor beschrijvingen',
  ', selected': ', geselecteerd',
  'captions settings': 'bijschriften-instellingen',
  'subtitles settings': 'ondertiteling-instellingen',
  'descriptions settings': 'beschrijvingen-instellingen',
  Text: 'Tekst',
  White: 'Wit',
  Black: 'Zwart',
  Red: 'Rood',
  Green: 'Groen',
  Blue: 'Blauw',
  Yellow: 'Geel',
  Magenta: 'Magenta',
  Cyan: 'Cyaan',
  Background: 'Achtergrond',
  Window: 'Venster',
  Transparent: 'Transparant',
  'Semi-Transparent': 'Semi-transparant',
  Opaque: 'Ondoorzichtig',
  'Font Size': 'Lettergrootte',
  'Text Edge Style': 'Stijl tekstrand',
  None: 'Geen',
  Raised: 'Verhoogd',
  Depressed: 'Ingedrukt',
  Uniform: 'Uniform',
  Dropshadow: 'Schaduw',
  'Font Family': 'Lettertype',
  'Proportional Sans-Serif': 'Proportioneel sans-serif',
  'Monospace Sans-Serif': 'Monospace sans-serif',
  'Proportional Serif': 'Proportioneel serif',
  'Monospace Serif': 'Monospace serif',
  Casual: 'Luchtig',
  Script: 'Script',
  'Small Caps': 'Kleine hoofdletters',
  Reset: 'Herstellen',
  [errorEnum.SET_ERR]: 'alle instellingen naar de standaardwaarden herstellen',
  Done: 'Klaar',
  'Caption Settings Dialog': 'Venster voor bijschriften-instellingen',
  [errorEnum.DIA_ERR]:
    'Begin van dialoogvenster. Escape zal annuleren en het venster sluiten.',
  'End of dialog window.': 'Einde van dialoogvenster.',
  Share: 'Delen',
  'Direct Link': 'Link',
  'Embed Code': 'Embed',
  Copy: 'Kopieer',
  Copied: 'Gekopieerd',
  Quality: ' ',
};
